module.exports = __webpack_public_path__ + "img/icon-nav1_blue.abb36ed1.svg";